import { useState } from 'react'
import IncludeExcludeFlagModal from '../modals/IncludeExcludeFlagModal'
import { FLAG_OPTIONS } from '../../../utils/flagOptions'

const FLAG_BY_KEY = Object.fromEntries(FLAG_OPTIONS.map(o => [o.key, o]))

/**
 * Chip verde (include) o rojo (exclude) de filtro Flag multi-select.
 * @param {'include'|'exclude'} mode
 * @param {Object} filters - { include_flag, exclude_flag }
 * @param {Function} updateFilter - (key, value) => void
 * @param {boolean} autoOpen
 * @param {Function} onRemove
 */
export default function IncludeExcludeFlagChip({ mode, filters, updateFilter, autoOpen = false, onRemove }) {
  const [open, setOpen] = useState(!!autoOpen)
  const filterKey = mode === 'include' ? 'include_flag' : 'exclude_flag'
  const selected = filters[filterKey] || []

  const handleRemove = (e) => { e.stopPropagation(); if (onRemove) onRemove() }
  const handleConfirm = (flags) => updateFilter(filterKey, flags)

  const color = mode === 'include'
    ? 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-800 dark:text-emerald-200 hover:bg-emerald-200 dark:hover:bg-emerald-900/60'
    : 'bg-rose-100 dark:bg-rose-900/40 text-rose-800 dark:text-rose-200 hover:bg-rose-200 dark:hover:bg-rose-900/60'

  const prefix = mode === 'include' ? '+Flag' : '−Flag'
  const MAX_FLAGS = 4

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        type="button"
        className={`group flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full transition-colors ${color}`}
      >
        {selected.length === 0 ? (
          <span>{prefix} (elegir)</span>
        ) : (
          <span className="flex items-center gap-0.5">
            <span className="font-semibold mr-0.5">{prefix}</span>
            {selected.slice(0, MAX_FLAGS).map(key => {
              const opt = FLAG_BY_KEY[key]
              return (
                <span key={key} title={opt?.label || key} className="inline-flex items-center">
                  {opt ? opt.render('sm') : <span>{key}</span>}
                </span>
              )
            })}
            {selected.length > MAX_FLAGS && (
              <span className="ml-0.5">+{selected.length - MAX_FLAGS}</span>
            )}
          </span>
        )}
        <span onClick={handleRemove} className="opacity-0 group-hover:opacity-100 transition-opacity ml-1 cursor-pointer" role="button" aria-label="Quitar filtro">
          ✕
        </span>
      </button>
      {open && (
        <IncludeExcludeFlagModal
          mode={mode}
          initialSelected={selected}
          onConfirm={handleConfirm}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
